export enum HorizontalAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export enum VerticalAlign {
    Top = 'top',
    Middle = 'middle',
    Bottom = 'bottom',
}

export interface Alignment {
    horizontal: HorizontalAlign;
    vertical: VerticalAlign;
}

export const renderFlexBoxAlignment = (align: HorizontalAlign): string => {
    switch (align) {
        case HorizontalAlign.Center:
            return 'center';
        case HorizontalAlign.Left:
            return 'flex-start';
        case HorizontalAlign.Right:
            return 'flex-end';
        default:
            return 'center';
    }
};

export const renderImageVerticalAlignment = (align: VerticalAlign): string => {
    switch (align) {
        case VerticalAlign.Top:
            return 'top';
        case VerticalAlign.Middle:
            return 'center';
        case VerticalAlign.Bottom:
            return 'bottom';
        default:
            return 'center';
    }
};
